import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { GuestRating as GuestRating$2, RatingContainer, Grade, Label, NumberOfAnswersText } from './GuestRating.style.js';
import texts from './GuestRating.texts.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useGlobals from '../../hooks/useGlobals.js';
import Icon from '../Icon/Icon.js';
import { ICON_COMMS_REVIEW } from '../../icons/ICON_COMMS_REVIEW.js';

var _excluded = ["rating", "onClick", "showLabel", "showScale", "beforeNumberOfAnswers", "numberOfAnswers", "afterNumberOfAnswers", "seo", "dontShowDecimal"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var GuestRating = function GuestRating(_ref) {
  var rating = _ref.rating,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick,
    _ref$showLabel = _ref.showLabel,
    showLabel = _ref$showLabel === void 0 ? false : _ref$showLabel,
    _ref$showScale = _ref.showScale,
    showScale = _ref$showScale === void 0 ? false : _ref$showScale,
    _ref$beforeNumberOfAn = _ref.beforeNumberOfAnswers,
    beforeNumberOfAnswers = _ref$beforeNumberOfAn === void 0 ? null : _ref$beforeNumberOfAn,
    _ref$numberOfAnswers = _ref.numberOfAnswers,
    numberOfAnswers = _ref$numberOfAnswers === void 0 ? null : _ref$numberOfAnswers,
    _ref$afterNumberOfAns = _ref.afterNumberOfAnswers,
    afterNumberOfAnswers = _ref$afterNumberOfAns === void 0 ? null : _ref$afterNumberOfAns,
    _ref$seo = _ref.seo,
    seo = _ref$seo === void 0 ? false : _ref$seo,
    _ref$dontShowDecimal = _ref.dontShowDecimal,
    dontShowDecimal = _ref$dontShowDecimal === void 0 ? false : _ref$dontShowDecimal,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useGlobals = useGlobals(),
    culture = _useGlobals.culture;
  if (typeof rating !== 'number' || rating < 1) {
    return false;
  }
  var displayRating = (Math.round(rating * 10) / 10).toString().replace('.', ',');
  if (displayRating.indexOf(',') < 0 && !dontShowDecimal) {
    displayRating += ',0';
  }
  var renderType = onClick ? 'button' : 'div';
  var guestRatingProps = _objectSpread({
    itemProp: !!numberOfAnswers && !!seo ? 'aggregateRating' : null,
    itemType: !!numberOfAnswers && !!seo ? 'https://schema.org/AggregateRating' : null,
    itemScope: !!numberOfAnswers && !!seo || null,
    onClick: onClick,
    type: onClick ? 'button' : null,
    as: renderType,
    $hasOnclick: !!onClick
  }, rest);
  return /*#__PURE__*/jsxs(GuestRating$2, _objectSpread(_objectSpread({}, guestRatingProps), {}, {
    title: texts.guestRating,
    children: [/*#__PURE__*/jsxs(RatingContainer, {
      children: [/*#__PURE__*/jsx(Icon, {
        "aria-hidden": "true",
        path: ICON_COMMS_REVIEW,
        size: "s"
      }), /*#__PURE__*/jsxs(Grade, {
        itemProp: !!numberOfAnswers && !!seo ? 'ratingValue' : null,
        children: [displayRating, showScale && /*#__PURE__*/jsx("span", {
          itemProp: !!numberOfAnswers && !!seo ? 'bestRating' : null,
          children: "/5"
        })]
      })]
    }), showLabel && !numberOfAnswers && /*#__PURE__*/jsx(Label, {
      "aria-hidden": "true",
      children: texts[culture].guestRating
    }), /*#__PURE__*/jsx("span", {
      className: "visually-hidden",
      children: "".concat(texts[culture].guestRating, ": ").concat(rating, "/5")
    }), numberOfAnswers > 0 && /*#__PURE__*/jsxs(NumberOfAnswersText, {
      children: [beforeNumberOfAnswers, /*#__PURE__*/jsxs("span", {
        itemProp: !!numberOfAnswers && !!seo ? 'ratingCount' : null,
        children: [' ', numberOfAnswers, ' ']
      }, "1"), afterNumberOfAnswers && "".concat(afterNumberOfAnswers.trim())]
    })]
  }));
};
var GuestRating$1 = GuestRating;

export { GuestRating$1 as default };
//# sourceMappingURL=GuestRating.js.map
